// src/App.js
import React from 'react';
import BetweenDateTimeInput from './BetweenDateTimeInput';

function App() {
  const handleChange = ({ mode, from, to }) => {
    console.log('User selection:', { mode, from, to });
  };

  return (
    <div className="govuk-width-container">
      <h1 className="govuk-heading-xl">Date-Time Demo</h1>
      <BetweenDateTimeInput onChange={handleChange} />
    </div>
  );
}

export default App;
